interface PaginationProps {
  page: number;
  totalPages: number;
  total: number;
  /** Einheit im Zähler, z. B. "Inserate" → "42 Inserate, Seite 1 von 3" */
  entityLabel: string;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  page,
  totalPages,
  total,
  entityLabel,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between mt-4">
      <div className="text-sm text-gray-500">
        {total} {entityLabel}, Seite {page} von {totalPages}
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="btn btn-outline px-3 py-1.5"
        >
          Zurück
        </button>
        <button
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className="btn btn-outline px-3 py-1.5"
        >
          Weiter
        </button>
      </div>
    </div>
  );
}
